import { Routes, Route } from "react-router-dom";
import DummyComponent from "./DummyComponent";
import UserTaasnetpage from "../components/Dashboard/User/Homepage/UserTaasnetpage";
import SignIn from "../pages/Auth/SignIn_updated";
import ForgotPasswordPage from "../pages/Auth/ForgotPassword";
import VerifyEmailPage from "../pages/Auth/VerifyPage";
import PasswordResetPage from "../pages/Auth/ResetPassword";
import { UserHomepage } from "../components/Dashboard/User/Homepage/UserHomepage_updated";
import Register from "../pages/Register/Register";
import { RegisterTalentForm } from "../components/RegisterTalentForm/RegisterTalentForm";
import withAuthentication from "../hoc/withAuthentication";
import { ProfileManagement } from "../components/Profile/ProfileManagement";
import UserLayout from "./UserLayout";
import UserDashboard_updated from "../components/Dashboard/UserDashboard/MainUserDashboard";
import TalentPage from "../pages/Talent/TalentPage";
import UserInteractionPage from "../pages/UserInteractionPage";
//import { Sing4YouCafePage } from "../components/StageLink/Sing4You/Sing4YouCafePage_bug_fixed";
import { Sing4YouCafePage } from "../components/StageLink/Sing4You/Sing4YouCafePage_bug_fixed_PVLC";
//import { Sing4YouCafePage } from "../components/StageLink/Sing4You/Sing4YouCafePage";
import { Sing4YouPerformerPage } from "../components/StageLink/Sing4You/Sing4YouPerformerPage";
import FeaturedEventDetail from "../components/Dashboard/Talent/Card/Featured_Card/FeaturedEventDetail";
import UserNotification from "./UserNotification";
import StageCardDetailsPage from "../components/Dashboard/UserDashboard/RecentCardCarousel/BookedStageCardDetailsPage";
import FeaturedEventsSection from "../components/Dashboard/Talent/Card/Featured_Card/FeatureEventCard";
import BookStageCardCarousel from "../components/Dashboard/UserDashboard/RecentCardCarousel/BookedStageModeCarousel";
import Homepage from "../pages/LandingPage/Home";
import AboutPage from "../pages/LandingPage/AboutPage";
import ContactPage from "../pages/LandingPage/contacts/Contactpage";
import UserSettingsPage from "../components/Profile/UserSettings/UserSettingPage";
import HelpPage from "../components/Help/HelpPage";
import SupportPage from "../components/Support/SupportPage";
import WalletDashboardNew from "../components/Wallet/WalletDashboard";
import WalletDashboard from "../components/Wallet/User/UserWalletPage_redefined";
import AddUsernamePage from "../pages/Auth/AddUsernamePage";
import TalentWalletDashboardNew from "../components/Wallet/Talent/TalentWalletDashboardNew";
import UserStageSessions from "../components/Dashboard/User/Sessions/UserStageSession";
import MyBookmarks from "../components/Dashboard/Talent/Card/UserCardDesign/MyBookmarks";
import MyDeck from "../components/Dashboard/Talent/Card/UserCardDesign/MyDeck";
import TicketSession from "../components/Dashboard/User/Sessions/TicketSession";
import ComingSoon from "../pages/LandingPage/ComingSoon";
import BusinessChoiceLanding from "../components/BusinessAccount/Register/BussinessChoiceLanding";
import { StageLinkHostPage } from "../components/StageLink/Host/StageLinkHostPage_native";  
import { KaraokeViewUser} from "../components/StageLink/Karaokecard/UserViewKaraoke/KaraokeViewUser";
import { Sing4YouAudiencePage } from "../components/StageLink/Sing4You/Sing4YouAudiencePage_bug_fixed_PVLC";
import PerformerPage from "../components/StageLink/Performer/PerformerPage";
import ModeratorPanelPage from "../components/StageLink/Moderator/ModeratorPanel";
const AuthenticatedLayout = withAuthentication(UserLayout);

const UserRoutes = () => {
  return (
    <Routes>
      <Route path="/home" element={<Homepage />} />
      <Route path="home/business-choice" element={<BusinessChoiceLanding />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/coming-soon" element={<ComingSoon />} />
      <Route path="/register" element={<Register />} />
      {/* <Route path="/register-talent-profile" element={<RegisterTalentForm />} /> */}
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/signup/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password?/OTP" element={<VerifyEmailPage />} />
      <Route
        path="/forgot-password/reset-password"
        element={<PasswordResetPage />}
      />
      <Route path="/add-username" element={<AddUsernamePage />} />

      {/* Main User Routes */}
        <Route path="/" element={<AuthenticatedLayout />}>
        <Route index element={<UserTaasnetpage />} />
        <Route path="TNpage" element={<UserTaasnetpage />} />
        <Route
          path="/stage-cards"
          element={<FeaturedEventsSection fromRoutes={true} />}
        />
        <Route path="dashboard" element={<UserDashboard_updated />} />
        <Route path="wallet" element={<WalletDashboard />} />
        <Route path="/notification" element={<UserNotification />} />
        <Route path="my-deck" element={<MyDeck />} />
        <Route path="my-bookmarks" element={<MyBookmarks />} />
        <Route path="register-talent" element={<RegisterTalentForm />} />
        <Route path="user" element={<UserTaasnetpage />} />
        <Route path="user/:id" element={<UserTaasnetpage />} />
        <Route path="talent/:id" element={<UserHomepage />} />
        <Route path="settings" element={<UserSettingsPage />} />
        <Route path="add-username" element={<AddUsernamePage />} />
        <Route path="about" element={<DummyComponent title="About" />} />
        <Route path="help" element={<HelpPage />} />
        <Route path="profile" element={<ProfileManagement />} />
        <Route path="talent/profile/:id" element={<TalentPage />} />
        <Route path="/stage-booking/:id" element={<StageCardDetailsPage />} />
        <Route path="/stage-booking" element={<BookStageCardCarousel />} />
        <Route path="/sessions/stagecard" element={<UserStageSessions />} />
        <Route path="userWallet" element={<WalletDashboardNew />} />
        <Route path="wallet" element={<WalletDashboard />} />
        <Route path="wallet/:id" element={<TalentWalletDashboardNew />} />

    
        <Route
          path="/interaction/:channel_name"
          element={<UserInteractionPage />}
        />
        <Route
          path="/sing4you-interaction/:channel_name"
          element={<UserInteractionPage />}
        />
        <Route
          path="/sing4you-audience/:channel_name"
          element={<Sing4YouAudiencePage />}
        />
        <Route
          path="/sing4you-host/:channel_name"
          element={<Sing4YouCafePage />}
        />
        <Route
          path="/sing4you-performer/:channel_name"
          element={<Sing4YouPerformerPage />}
        />
        <Route
          path="/stage-live-host/:channel_name"
          element={<StageLinkHostPage />}
        />
        <Route
          path="/moderator/:channel_name"
          element={<ModeratorPanelPage />}
        />
        <Route
          path="/stage-live-performance/:channel_name"
          element={<PerformerPage />}
        />
        <Route path="/featured-event" element={<FeaturedEventsSection />} />
        <Route path="/featured-event/:id" element={<FeaturedEventDetail />} />

        <Route path="/tickets" element={<TicketSession />} />
        <Route path="/karaoke-card" element={<KaraokeViewUser />} />

        <Route path="*" element={<h1>Page not found</h1>} />
      </Route>
    </Routes>
  );
};

export default UserRoutes;
